import {useDebugValue} from 'react';

import {useSettings} from './useSettings';

const defaultGuestsSettings = {
    disableButton: false,
    isOpen: false,
    readOnly: false
};

function useGuestsSettings(props) {
    const {
        guestsSettings: propsGuestsSettings
    } = props;

    const {
        initialSettings: initialGuestsSettings,
        settings: guestsSettings,
        changeSettings: changeGuestsSettings
    } = useSettings(defaultGuestsSettings, propsGuestsSettings);

    const result = {
        initialGuestsSettings,
        guestsSettings,
        changeGuestsSettings
    };

    useDebugValue(result);

    return result;
}

export {useGuestsSettings};
